import { Injectable } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import jwt_decode from "jwt-decode";
import { ChangePasswordComponent } from "../dialog/change-password/change-password.component";
import { Router } from "@angular/router";
import { UserService } from "src/app/share/service/user.service";

@Injectable({
	providedIn: "root"
})
export class AuthService {
	private tokenKey = "token";

	constructor(
		public bottomSheet: MatBottomSheet,
		private router: Router,
		public userService: UserService
	) {}

	setToken(token: string) {
		document.cookie = `${this.tokenKey}=${token};path=/;`;

		this.savePermissionsData(token);
	}

	savePermissionsData(token: any) {
		let decodedToken = this.decodeToken(token);
		let roleKey =
			"http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

		localStorage.setItem("getUserRole", JSON.stringify(decodedToken[roleKey]));
		localStorage.setItem(
			"getFunctionalPermissions",
			JSON.stringify(decodedToken.FunctionPermissions)
		);
		localStorage.setItem(
			"getProductPermissions",
			JSON.stringify(decodedToken.ProductPermissions)
		);
		localStorage.setItem(
			"getScreenPermissions",
			JSON.stringify(decodedToken.ScreenPermissions)
		);
	}

	logout() {
		document.cookie = `${this.tokenKey}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
		const partnerCode = localStorage.getItem("partner");
		if (["carsome", "mg", "fundingsocieties", "imotorbike"].includes(partnerCode)) {
			this.userService.user = null;
			this.router.navigate([partnerCode]);
		} else {
			window.location.reload();
		}

		this.clearLocalStorage();
	}

	getToken() {
		return this.getCookie(this.tokenKey);
	}

	getUserId() {
		let token = this.getToken();
		let decoded = jwt_decode(token);
		return decoded[
			"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
		];
	}

	private clearLocalStorage() {
		localStorage.removeItem("getFunctionalPermissions");
		localStorage.removeItem("getProductPermissions");
		localStorage.removeItem("getScreenPermissions");
	}

	decodeToken(token: any): DecodedTokenInterface {
		return jwt_decode(token);
	}

	isTokenExpired(): boolean {
		let token = this.getToken();
		if (!token) return false;
		let decoded = jwt_decode(token);
		let expireTime = new Date(decoded["exp"] * 1000);

		return expireTime < new Date();
	}

	isLoggedIn(): boolean {
		if (this.getToken()) {
			return !this.isTokenExpired();
		}
		return false;
	}

	changePassword() {
		let dialog = this.bottomSheet.open(ChangePasswordComponent, {
			backdropClass: "sidenav-container"
			// data: {
			// },
		});

		dialog.afterDismissed().subscribe((x) => {
			if (x) {
			}
		});
	}

	private getCookie(cname): string | null {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(";");
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}
}

export interface DecodedTokenInterface {
	Code: string;
	FunctionPermissions: string[];
	Id: string;
	IsActive: string;
	ProductPermissions: string[];
	ScreenPermissions: string[];
	exp: number;
	"http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string[];
}
